import AwesomeCard from "@/components/common/awesome-card";
import ImageGallery from "@/components/common/image-gallery";
import { memo } from "react";

function NosLocaux() {
    return (<AwesomeCard title={"Nos locaux"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
         <div className={'my-8'}>
                            <ImageGallery images={
                                Array.from({ length: 4 }).map((_, index) => ({
                                src: `/images/nos-locaux/${index + 1}.jpg`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                                }))
                            } aspectRatio={"video"} />
                            </div>
    </AwesomeCard>)
}

export default memo(NosLocaux);
